<template>
<div>
    <v-card>
      <v-toolbar dense class="toolbar" height="35px" color="grey lighten-3">             
        <v-spacer></v-spacer>         
      </v-toolbar>
       <ag-grid-vue style="width:100%;height:100%"
                 class="ag-theme-balham"
                 domLayout="autoHeight"
                 :columnDefs="columnDefs"
                 :enableFillHandle="true"
                 :defaultColDef="defaultColDef"                 
                 :context="context"
                 @cell-value-changed="gridDataChanged"
                 :rowData="trasactions">
                </ag-grid-vue>
    </v-card>
    
</div>
</template>

<script>
  import { validationMixin } from 'vuelidate'
  import {AgGridVue} from "ag-grid-vue";  
  import { mapState, mapActions } from 'vuex'  
  import { customerService } from './../../services/'     
  import moment from 'moment'   

  export default {
    name: 'finance',
    computed: {
        ...mapState('invoice', ['selectedInvoice','newInvoiceData']),
    },
    
    mixins: [validationMixin],  
    components: {
            AgGridVue,            
        },
    beforeMount() {
        this.context = { componentParent: this };
    },
    mounted() {      
      this.loadInvoices(this.selectedCustomerId)
    },
    props: ['selectedCustomerId'],
      watch: {         
        selectedCustomerId: function(newVal, oldVal) {
          console.log(oldVal)
          this.loadInvoices(newVal)        
      }
    },
    data: () => ({
      invoice: {
        id: null,
        date: null,        
      },
      trasactions:[],
      flightData:[],
      context: null,
      columnDefs:[
          
          { headerName: 'Trans Date' , field: 'createdAt' ,minWidth:100,valueFormatter: params => params.data && params.data.createdAt ? moment(params.data.createdAt).format('DD-MM-YYYY') : '-'},
          { headerName: 'Customer No' , field: 'customerId',minWidth:100 },
          { headerName: 'Customer Name ' , field: 'customer.name',minWidth:150 },
          { headerName: 'Cash ' , field: 'cash' ,minWidth:100 },
          { headerName: 'Cheque ' , field: 'cheque' ,minWidth:100 },
          { headerName: 'Card ' , field: 'card' ,minWidth:100 },
          { headerName: 'Bank Deposit ' , field: 'bankDeposit' ,minWidth:100 },
          { headerName: 'Cr Amount ' , field: 'amountCredit' ,minWidth:100 },
          { headerName: 'Db Amount ' , field: 'amountDebit' ,minWidth:100 },
          { headerName: 'Description', field:'description' ,minWidth:150 },
          { headerName: 'Additional Info ' , field: '' ,minWidth:120 },
          { headerName: 'Bank Charges ' , field: 'bankCharges' ,minWidth:100 },
          { headerName: 'Balance', field:'customer.balance' ,minWidth:80 },
          { headerName: 'EmployeeName', field:'customer.name' ,minWidth:120 },
          { headerName: 'EmployeeID', field:'createdBy' ,minWidth:100 },          
          
          {
        headerName: "Action",
        field: "value",       
        editable: false,        
        width: 150
      },
        ],       
        menuItems:["sabre","gds"],
        defaultColDef: {
          flex: 1,
        editable: true
      },
      suppliers: [],
      gdsValues: []
    }),
    created () {
      // let self = this
    },    
    methods: {
      ...mapActions('invoice', ['updateFlightData']),        
      gridDataChanged () {},
      loadInvoices(customerId)  {
        if (!customerId) return;
        let self=this
        self.isLoading=true
        customerService.getAccountTransactions(customerId).then(trasactions=> {              
              self.trasactions=trasactions
              self.isLoading=false
        }).catch(err => {
          console.error(err);
          self.isLoading=false;
        })
      }       
    }
  }
</script>

<style lang="scss">
  .thead-container {
    height: auto !important;
    padding: 0px 0 !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .td {
    height: 28px !important;
  }

</style>

<style scoped>
  .v-btn {
    margin: 0px 0;
    height:auto;
  }
  .img-icons {
    height: 24px;
  }
  .menu-logo {
    height: 20px;
  }
  .table-remove-icon {
    min-width: auto
  }
  .v-container {
    padding-top: 0px;
    padding-bottom: 0px !important;
  }
</style>